import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0a15e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-centered" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "payment" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "dot-flashing" }),
      /*#__PURE__*/_createElementVNode("h2", null, "Payment Pending"),
      /*#__PURE__*/_createElementVNode("p", null, "We'll notify you via email once your payment has been processed and finalized")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceSteps = _resolveComponent("InvoiceSteps")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_InvoiceSteps, {
      steps: _ctx.steps,
      currentStep: 3,
      currentColour: "#F2994A"
    }, null, 8, ["steps"]),
    _hoisted_1
  ], 64))
}